import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { StarRating } from '../ui/StarRating';
const testimonials = [{
  text: 'Compré el Kit un domingo. El lunes fabricaba 4 soportes de laptop. Miércoles ya había vendido 3 por Wallapop. Increíble.',
  name: 'Antonio R.',
  role: 'Carpintero · Málaga'
}, {
  text: 'Pensé que era otro PDF teórico más. Pero esto es diferente. Los planos son claros, las medidas exactas. Ya fabrico 2 torres Montessori a la semana.',
  name: 'Paco J.',
  role: 'Manitas · Madrid'
}, {
  text: 'Lo que más me gustó fue el Bono de Precios. Por fin sé cuánto cobrar sin sentirme ladrón. Gano 60€ de margen por tabla.',
  name: 'Laura G.',
  role: 'Profesora y Artesana · Zaragoza'
}, {
  text: 'Las plantillas de Wallapop funcionan. Publico, y al día siguiente tengo consultas serias. Sin regateo.',
  name: 'Iñaki A.',
  role: 'Bilbao'
}, {
  text: 'El Radar de Demanda me ahorró fabricar 3 productos que nadie hubiera comprado. Ahora solo hago lo que vende.',
  name: 'Sergio B.',
  role: 'Valencia'
}, {
  text: 'El Pack Cliente Feliz cambió todo. Mis clientes ahora dejan reseñas de 5 estrellas y me recomiendan a sus amigos. Puse las tarjetas de cuidado y la diferencia fue instantánea.',
  name: 'María C.',
  role: 'Barcelona'
}];
export function Testimonials() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-173" data-mp="2bic69c8it5ha">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-174" data-mp="2bh1055rlrln0">
        <SectionTag icon="⭐" data-id="element-175" data-mp="26ktule34cc5l">Testimonios reales</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-176" data-mp="22i77trlb1hf9">
          Carpinteros y Manitas de toda España ya están facturando.
        </h2>
        <div className="mt-4 flex items-center justify-center gap-2" data-id="element-177" data-mp="r3aalueyvlwt">
          <StarRating size={18} data-id="element-178" data-mp="r1h209ksmrm6" />
          <span className="text-sm text-muted" data-id="element-179" data-mp="m3xkn0sstyq0">+320 reseñas verificadas</span>
        </div>
      </div>

      <div className="mx-auto mt-8 grid max-w-6xl gap-4 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-3" data-id="element-180" data-mp="nl4ag4u06l00">
        {testimonials.map((t, i) => <m.div key={t.name} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 3 * 0.08
      }} className="flex flex-col rounded-2xl border border-brown/20 bg-white p-6 shadow-card" data-id="element-181" data-mp="sjxt0bo5d271" data-mpi={i}>
            <div className="flex items-center justify-between" data-id="element-182" data-mp="9md2l05qhvkb">
              <StarRating size={14} data-id="element-183" data-mp="9nxyat3sbkjr" />
              <span aria-hidden="true" data-id="element-184" data-mp="3r2ux49pgl7e9">🇪🇸</span>
            </div>
            <p className="mt-3 flex-1 text-sm leading-relaxed text-ink/90" data-id="element-185" data-mp="3r0i5f4twfio0">"{t.text}"</p>
            <div className="mt-4 border-t border-brown/10 pt-3" data-id="element-186" data-mp="3vzczx418avny">
              <p className="text-sm font-semibold text-ink" data-id="element-187" data-mp="3i2zhnsoveq8f">{t.name}</p>
              <p className="text-xs text-muted" data-id="element-188" data-mp="3n19e06mbzwvm">{t.role}</p>
            </div>
          </m.div>)}
      </div>

      <p className="mt-6 text-center text-sm text-muted sm:text-base" data-id="element-189" data-mp="33g0sk4dhk7wv">
        Más de <span className="font-semibold text-brown" data-id="element-190" data-mp="2ygefbuxnqro2">5.200 piezas vendidas</span> por artesanos que ya
        usan EL KIT DEL TALLER RENTABLE.
      </p>
    </section>;
}